import { apiConfig } from '../api-config';

export const getContestationAll = async (TokenKey: string) => apiConfig
  .get(`api/Contestation/get-contestation-territory-all?&tokenKey=${TokenKey}`)
  .then((resp) => resp.data.objectResult)
  .catch(async (error) => {
    if (error.response.status === 401) {
      return getContestationAll;
    }
    return [];
  });
